



































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import PanelActionButton, {
  PanelActionButtonItemType,
} from '@/components/atoms/PanelActionButton.vue';
import PanelContent from '@/components/atoms/PanelContent.vue';
import LinkMenuLinks from '@/components/molecules/LinkMenuLinks.vue';
import { BusEvent, BusEventTargets } from '@/containers/globals/BusEvent';
import { i18n } from '@/plugins/i18n/i18n';
import { ID, LinkMenu } from '@/types/type';

@Component({
  components: {
    LinkMenuLinks,
    PanelActionButton,
    PanelContent,
  },
})
export default class PortalLinkMenusPanel extends Vue {
  private icon: string = 'link';
  private panelTitle: string = i18n.tc('portal.links');
  private noData: string = i18n.tc('portal.noData');

  private buttonActions: PanelActionButtonItemType[] = [
    {
      title: i18n.tc('portal.updateLink'),
      event: 'edit-link',
    },
  ];

  @Prop()
  private menus!: LinkMenu[];

  @Prop()
  private canEditLink!: boolean;

  @Emit('edit-link-action')
  private editLink(): void {}

  @Emit('link-menu-opened')
  private linkOpened(id: ID): ID {
    return id;
  }
}
